import { useNavigate } from 'react-router-dom';
import { Button, Center, Stack, Text, Title } from '@mantine/core';

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Center mih="100dvh" px="md">
      <Stack align="center" gap="sm" maw={420} ta="center" role="alert">
        <Title order={1} fz={48}>
          404
        </Title>
        <Text fw={600}>Страница не найдена</Text>
        <Text c="dimmed" size="sm">
          Возможно, ссылка устарела или у вас нет доступа к этому разделу.
        </Text>
        <Button variant="filled" onClick={() => navigate('/', { replace: true })} mt="xs">
          Вернуться на главную
        </Button>
      </Stack>
    </Center>
  );
}
